'use strict';


export function findInput(element) {
	var input;
	var inputs = ['input', 'textarea', 'select'];
	for (var i = 0; i < 3; i++) {
		input = element.find(inputs[i]);
		if (input.length > 0) {
			return input;
		}
	}
	throw 'No input, select, or textarea found';
}
